<template>
<div v-if="isLoaded">
    <div v-if="user !== 'error'">
        <h1>{{ isCurrentUser ? $t('userProfile') : $t('userView')}}</h1>
        <!-- <el-button
            style="float: right; font-size: 20px" 
            icon="el-icon-edit"
            type="primary" 
            @click="$router.push({name: 'UserEdit', params: {user: user, isEdit: true, isCurrentUser: isCurrentUser}})"
            /> -->

        <el-card>
            <table>
                <tr>
                    <td class="res-name"> {{ $t('usersName') }} </td>
                    <td class="">{{user.name ? user.name : '/'}}</td>
                </tr>
                <!-- <tr>
                    <td class="res-name"> Logo </td>
                    <td class="res-value"><img :src="url +  user.logo + '?time=' + timestamp"></td>
                </tr> -->
                <tr>
                    <td class="res-name"> {{ $t('usersEmail') }} </td>
                    <td class="">{{user.email ? user.email : '/'}}</td>
                </tr>
                <tr v-if="isCurrentUser">
                    <td class="res-name"> {{ $t('usersPassword') }} </td>
                    <td class=""> ******* 
                        <br>
                        <small @click="$router.push({ name: 'DashPasswordChange' })"> {{ $t('usersChangePassword') }} </small>
                    </td>
                </tr>
                <tr>
                    <td class="res-name">  {{ $t('usersProvider') }}  </td>
                    <td class="res-value">
                        <lang-tabs-view :param="user.provider ? {name: 'SingleProvider', params: {id: user.provider.id}} : {}" :input="user.provider ? user.provider.display_name : ''"/>
                    </td>
                </tr>
                <tr v-if="user.created_at">
                    <td class="res-name"> {{ $t('usersCreatedAt') }} </td>
                    <td class="">{{ user.created_at }}</td>
                </tr>
                <tr v-if="user.updated_at">
                    <td class="res-name"> {{ $t('usersUpdatedAt') }} </td>
                    <td class="">{{ user.updated_at }}</td>
                </tr>
            </table>
            <view-shared-buttons :path="path"/>  
        </el-card>
    </div>
    <div v-else>
        <not-found/>
    </div>
</div>
</template>

<script>
import {ImageUrl} from '@/main'
import {mapGetters} from 'vuex'
import api from '@/api/api'
import LayoutHeaders from '../LayoutPart/LayoutHeaders'
import LangTabsView from '../LangTabs/LangTabsView'
import ViewSharedButtons from '../Shared/ViewSharedButtons'
import NotFound from '../NotFound'

export default {
    components: {
        LayoutHeaders,
        LangTabsView,
        ViewSharedButtons,
        NotFound
    },
    data () {
        return {
            emptyText: '',
            isCurrentUser: false,
            isLoaded: false,
            path: '',
            user: {},
            url: ImageUrl
        }
    },
    computed: {
        ...mapGetters({
            getUser: 'getCurrentUser'
        }),
        timestamp() {
            return Date.now();
        }
    },
    async created () {
        let user
        if (this.$route.params.id) {
            await api.fetchSingleUser(this.$route.params.id)
            .then((res) => {
                user = res.data.data
            })
            .catch((err) => 
                user = 'error'
            )
            this.user = user
            
            
        } else {
            this.isCurrentUser = true
            this.$store.dispatch('fetchSelf')
            this.user = this.getUser
            this.provider = this.user.provider ? `dashboard/provider/${this.user.provider.id}` : ''
        }
        this.isLoaded = true
    },
    methods: {
        resetPassword () {

        }
    }
}
</script>

<style scoped>

h1 {
    color: grey;
    font-weight: 500;
    margin-left: 5px;
    display: inline-block;
}

table {
    width: 100%;
}

table > tr > td{
    padding: 20px !important;
    border-bottom: 1px solid #e6e6e6;
    
}

table > tr:last-child > td {
    border: none;
}

table > tr > td:nth-child(2) {
    position: relative;
    margin-left: -3px;
    display: block;
    margin-top: 1px;
}

.res-value-clickable {
    color: #409EFF !important;
    cursor: pointer;
}

.res-name {
    width: 200px;
    color: grey;
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 10px;
}

small {
    color: #409EFF !important;
    cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/Users/UserView.vue